import { AcSelectOption, AcSelectValue } from '@ac/web-components';

export const handleOnChange =
  <T extends { id: string }>(
    array: T[],
    handler: (item: T | undefined) => void
  ) =>
  (value: Array<AcSelectOption<AcSelectValue>>): void =>
    handler(array.find((item) => item.id === value[0].value));
